export class ReportFrontDeskFilterModel {
  PatientId: string;
  ContactId: string;
  size: string;
  envelopFor: string;
  ParentTreatmentPlanningID: string;
  TreatmentPlanningID: string;
}
